export enum ProjectType {
  Client,
  PublicSchedule,
}
